"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Constants = require("../utils/constants");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var createSharingMessageActionText_1 = require("../utils/createSharingMessageActionText");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var getSharingMessageAction_1 = require("../utils/getSharingMessageAction");
var acceptInvite_1 = require("../actions/acceptInvite");
var showCalendar_1 = require("../actions/showCalendar");
var owa_sharing_strings_1 = require("owa-strings/owa-sharing-strings");
var mobx_react_1 = require("mobx-react");
var styles = require('../styles/SharingAcceptButton.scss');
var SharingAcceptButton = /** @class */ (function (_super) {
    tslib_1.__extends(SharingAcceptButton, _super);
    function SharingAcceptButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onAcceptButtonClicked = function (evt) {
            _this.setState({ isLoading: true });
            acceptInvite_1.default(_this.props.item.ItemId).then(function (success) {
                _this.setState({ isLoading: false, successfulAccept: success });
            });
        };
        _this.onViewCalendarButtonClicked = function (evt) {
            var newWindow = window.open();
            showCalendar_1.default(newWindow);
        };
        _this.state = { isLoading: false, successfulAccept: false };
        return _this;
    }
    SharingAcceptButton.prototype.render = function () {
        var item = this.props.item;
        var sharingMessageAction = getSharingMessageAction_1.default(item);
        return this.renderActionButton(sharingMessageAction);
    };
    SharingAcceptButton.prototype.renderActionButton = function (sharingMessageAction) {
        if (!sharingMessageAction) {
            return null;
        }
        if (this.state.isLoading) {
            return (React.createElement("div", null,
                React.createElement(Spinner_1.Spinner, { className: styles.spinner, size: Spinner_1.SpinnerSize.small }),
                React.createElement("span", null, owa_sharing_strings_1.default.addingCalendarLoadingText)));
        }
        var primary = sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;
        if (this.state.successfulAccept) {
            var text = createSharingMessageActionText_1.default(Constants.VIEW_CALENDAR);
            return primary ? (React.createElement(Button_1.PrimaryButton, { text: text, onClick: this.onViewCalendarButtonClicked })) : (React.createElement(Button_1.DefaultButton, { text: text, onClick: this.onViewCalendarButtonClicked }));
        }
        else {
            var action = this.state.successfulAccept
                ? Constants.VIEW_CALENDAR
                : sharingMessageAction.Action;
            var text = createSharingMessageActionText_1.default(action);
            var primary_1 = sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;
            return primary_1 ? (React.createElement(Button_1.PrimaryButton, { text: text, onClick: this.onAcceptButtonClicked })) : (React.createElement(Button_1.DefaultButton, { text: text, onClick: this.onAcceptButtonClicked }));
        }
    };
    SharingAcceptButton = tslib_1.__decorate([
        mobx_react_1.observer
    ], SharingAcceptButton);
    return SharingAcceptButton;
}(React.Component));
exports.default = SharingAcceptButton;
//# sourceMappingURL=SharingAcceptButton.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/components/SharingAcceptButton.js
// module id = 3867
// module chunks = 96